// podtemat1_kanoniczna.js

import {
  generateTask as generateReadCircleFromEquationTask,
  renderTask as renderReadCircleFromEquationTask,
  renderAnswer as renderAnswerReadCircleFromEquationTask,
  renderExplanation as renderExplanationReadCircleFromEquationTask,
  renderInput as renderInputReadCircleFromEquationTask,
  renderUserAnswer as renderUserAnswerReadCircleFromEquationTask,
  checkAnswer as checkAnswerReadCircleFromEquationTask,
} from "./podtemat1_kanoniczna_types/ReadCircleFromEquationTask";

import {
  generateTask as generateWriteCircleEquationTask,
  renderTask as renderWriteCircleEquationTask,
  renderAnswer as renderAnswerWriteCircleEquationTask,
  renderExplanation as renderExplanationWriteCircleEquationTask,
  renderInput as renderInputWriteCircleEquationTask,
  renderUserAnswer as renderUserAnswerWriteCircleEquationTask,
  checkAnswer as checkAnswerWriteCircleEquationTask,
} from "./podtemat1_kanoniczna_types/WriteCircleEquationTask";

import {
  generateTask as generateWriteCircleFromCenterAndPointTask,
  renderTask as renderWriteCircleFromCenterAndPointTask,
  renderAnswer as renderAnswerWriteCircleFromCenterAndPointTask,
  renderExplanation as renderExplanationWriteCircleFromCenterAndPointTask,
  renderInput as renderInputWriteCircleFromCenterAndPointTask,
  renderUserAnswer as renderUserAnswerWriteCircleFromCenterAndPointTask,
  checkAnswer as checkAnswerWriteCircleFromCenterAndPointTask,
} from "./podtemat1_kanoniczna_types/WriteCircleFromCenterAndPointTask";

import {
  generateTask as generateWriteCircleFromDiameterTask,
  renderTask as renderWriteCircleFromDiameterTask,
  renderAnswer as renderAnswerWriteCircleFromDiameterTask,
  renderExplanation as renderExplanationWriteCircleFromDiameterTask,
  renderInput as renderInputWriteCircleFromDiameterTask,
  renderUserAnswer as renderUserAnswerWriteCircleFromDiameterTask,
  checkAnswer as checkAnswerWriteCircleFromDiameterTask,
} from "./podtemat1_kanoniczna_types/WriteCircleFromDiameterTask";


export function generateTasks() {
  return [
    { type: "ReadCircleFromEquationTask", ...generateReadCircleFromEquationTask() },
    { type: "WriteCircleEquationTask", ...generateWriteCircleEquationTask() },
    { type: "WriteCircleFromCenterAndPointTask", ...generateWriteCircleFromCenterAndPointTask() },
    { type: "WriteCircleFromDiameterTask", ...generateWriteCircleFromDiameterTask() },

  ];
}

export function renderTask(task) {
  if (task.type === "ReadCircleFromEquationTask") {
    return renderReadCircleFromEquationTask(task);
  }
  if (task.type === "WriteCircleEquationTask") {
    return renderWriteCircleEquationTask(task);
  }
  if (task.type === "WriteCircleFromCenterAndPointTask") {
    return renderWriteCircleFromCenterAndPointTask(task);
  }
    if (task.type === "WriteCircleFromDiameterTask") {
  return renderWriteCircleFromDiameterTask(task);
  }
}

export function renderInput(task, onChange) {
  if (task.type === "ReadCircleFromEquationTask") {
    return renderInputReadCircleFromEquationTask(task, onChange);
  }
  if (task.type === "WriteCircleEquationTask") {
    return renderInputWriteCircleEquationTask(task, onChange);
  }
  if (task.type === "WriteCircleFromCenterAndPointTask") {
    return renderInputWriteCircleFromCenterAndPointTask(task, onChange);
  }
  if (task.type === "WriteCircleFromDiameterTask") {
  return renderInputWriteCircleFromDiameterTask(task, onChange);
}

}

export function renderAnswer(task) {
  if (task.type === "ReadCircleFromEquationTask") {
    return renderAnswerReadCircleFromEquationTask(task);
  }
  if (task.type === "WriteCircleEquationTask") {
    return renderAnswerWriteCircleEquationTask(task);
  }
  if (task.type === "WriteCircleFromCenterAndPointTask") {
    return renderAnswerWriteCircleFromCenterAndPointTask(task);
  }
    if (task.type === "WriteCircleFromDiameterTask") {
  return renderAnswerWriteCircleFromDiameterTask(task);
  }
}

export function renderExplanation(task) {
  if (task.type === "ReadCircleFromEquationTask") {
    return renderExplanationReadCircleFromEquationTask(task);
  }
  if (task.type === "WriteCircleEquationTask") {
    return renderExplanationWriteCircleEquationTask(task);
  }
  if (task.type === "WriteCircleFromCenterAndPointTask") {
    return renderExplanationWriteCircleFromCenterAndPointTask(task);
  }
  if (task.type === "WriteCircleFromDiameterTask") {
  return renderExplanationWriteCircleFromDiameterTask(task);
}

}

export function renderUserAnswer(task) {
  if (task.type === "ReadCircleFromEquationTask") {
    return renderUserAnswerReadCircleFromEquationTask(task);
  }
  if (task.type === "WriteCircleEquationTask") {
    return renderUserAnswerWriteCircleEquationTask(task);
  }
  if (task.type === "WriteCircleFromCenterAndPointTask") {
    return renderUserAnswerWriteCircleFromCenterAndPointTask(task);
  }
  if (task.type === "WriteCircleFromDiameterTask") {
  return renderUserAnswerWriteCircleFromDiameterTask(task);
}

}

export function checkAnswer(task, userAnswer) {
  if (task.type === "ReadCircleFromEquationTask") {
    return checkAnswerReadCircleFromEquationTask(task, userAnswer);
  }
  if (task.type === "WriteCircleEquationTask") {
    return checkAnswerWriteCircleEquationTask(task, userAnswer);
  }
  if (task.type === "WriteCircleFromCenterAndPointTask") {
    return checkAnswerWriteCircleFromCenterAndPointTask(task, userAnswer);
  }
  if (task.type === "WriteCircleFromDiameterTask") {
  return checkAnswerWriteCircleFromDiameterTask(task, userAnswer);
}
}

